import styled from 'styled-components';
import { Flex } from '#atoms';
import { Lecture } from '#types/lectures';
import { formatNumberWithCommas } from '#utils/Numbers';

type ItemProps = {
  lecture: Lecture;
};

export default function Item({ lecture }: ItemProps) {
  return (
    <Wrapper>
      <Flex align="center" justify="space-between">
        {lecture.isTitle && (
          <>
            <Label>정규</Label>
            <Badge>대표</Badge>
          </>
        )}
        {lecture.isOnePoint && <Label>원포인트</Label>}
        {lecture.isOt && <Label>체험</Label>}
      </Flex>
      <Title>{lecture.title}</Title>
      <Description>{lecture.body}</Description>
      <PriceWrapper align="flex-end" justify="flex-end" gap={2}>
        <Price>{formatNumberWithCommas(lecture.price)}원</Price>
        <Count> / 회</Count>
      </PriceWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.article`
  border-radius: 8px;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.palette.gray600};
  background-color: ${({ theme }) => theme.palette.gray800};
`;

const Label = styled.div`
  color: ${({ theme }) => theme.palette.brand300};
  font-size: 13px;
  font-weight: 500;
`;

const Badge = styled.div`
  padding: 2.5px 6px;
  border-radius: 22px;
  background-color: ${({ theme }) => theme.palette.brand400};
  color: ${({ theme }) => theme.palette.gray15};
  font-size: 10px;
  font-weight: 500;
`;

const Title = styled.div`
  margin-top: 8px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.gray15};
`;

const Description = styled.div`
  margin-top: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.gray100};
`;

const PriceWrapper = styled(Flex)`
  margin-top: 12px;
`;

const Price = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.gray15};
`;

const Count = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.gray15};
  padding-bottom: 2px;
`;
